const DEFAULT_REWARD_STYLE = {
  type: "default",
  background: "#64748B",
  color: "#FFFFFF",
  boxShadow: "none",
  icon: "gift",
};

const REWARD_STYLES = {
  credit: {
    type: "credit",
    background: "#3B82F6",
    color: "#FFFFFF",
    boxShadow: "none",
    icon: "coin",
  },
  cash: {
    type: "cash",
    background: "#22C55E",
    color: "#052E16",
    boxShadow: "none",
    icon: "wallet",
  },
  freeSpin: {
    type: "free-spin",
    background: "#8B5CF6",
    color: "#FFFFFF",
    boxShadow: "none",
    icon: "rotate",
  },
  jackpot: {
    type: "jackpot",
    background: "linear-gradient(135deg, #FDE047, #F59E0B)",
    color: "#451A03",
    boxShadow: "0 0 18px rgba(245, 158, 11, 0.8)",
    icon: "crown",
  },
};

export function getRewardStyle(value) {
  const normalizedValue = String(value || "").trim().toLowerCase();

  if (normalizedValue.includes("jackpot")) {
    return REWARD_STYLES.jackpot;
  }

  if (normalizedValue.includes("free spin")) {
    return REWARD_STYLES.freeSpin;
  }

  if (normalizedValue.includes("cash")) {
    return REWARD_STYLES.cash;
  }

  if (normalizedValue.includes("credit")) {
    return REWARD_STYLES.credit;
  }

  return DEFAULT_REWARD_STYLE;
}
